import type { QueryClient } from '@tanstack/react-query'
import { format } from 'date-fns'

import type { TAtendimento, TUltimoAtendimento } from '@/features/atendimento/interfaces'
import { atendimentoKeys } from '@/features/atendimento/utils/queries'
import { queryClient } from '@/infra'
import { getIniciaisPrimeiroUltimoNome } from '@/utils'
import dateFormatter from '@/utils/date-formatter/date-formatter'

export class AtualizadorOtimistaUltimosAtendimentos {
  constructor(private readonly _queryClient: QueryClient = queryClient) {}

  private readonly adicionarAoTop = (novoAtendimento: TUltimoAtendimento, lista: TUltimoAtendimento[]) => {
    return [novoAtendimento, ...lista]
  }

  atualizar(atendimento: TAtendimento) {
    const clienteId = atendimento.cliente.id

    this._queryClient.setQueryData<TUltimoAtendimento[]>(atendimentoKeys.ultimosAtendimentos(), (oldList) => {
      if (!oldList) return oldList

      const index = oldList.findIndex((item) => item.clienteId === clienteId)

      const novoAtendimento: TUltimoAtendimento = {
        id: atendimento.id,
        quantidadeDias: 0,
        sigla: getIniciaisPrimeiroUltimoNome(atendimento.cliente.nome),
        diaMes: dateFormatter.formatar(new Date(), 'dd/MM'),
        clienteId: atendimento.cliente.id,
        nome: atendimento.cliente.nome,
        telefone: atendimento.cliente.telefone,
        cpf: atendimento.cliente.cpf,
      }
      if (index === -1) return this.adicionarAoTop(novoAtendimento, oldList)
      const ultimoAtendimentoCliente = oldList[index]!
      const ultimoAtendimentoAtualizado: TUltimoAtendimento = {
        ...ultimoAtendimentoCliente,
        id: atendimento.id,
        quantidadeDias: 0,
        diaMes: format(new Date(), 'dd/MM'),
      }

      const listaDestacada = [...oldList.slice(0, index), ...oldList.slice(index + 1)]
      return this.adicionarAoTop(ultimoAtendimentoAtualizado, listaDestacada)
    })
  }
}
